import Form from "../../../components/form/Form";
import PageContainer from "../../../components/resources/Resources-container";
import ContentItems from "../../../components/resources/contents/Content-items";
import SupportItems from "../../../components/resources/supports/Support-items";
import {
  getResources,
  updateResource,
  deleteResource,
} from "../../../apis/resourcesApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";
import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingContext from "../../../context/LoadingContext";
import UserContext from "../../../context/UserContext";
import openSocket from "socket.io-client";
import getApiBaseUrl from "../../../utils/getApiBaseUrl";
function ResourcePages(props) {
  const [state, setState] = useState({
    resources: [],
    editResource: null,
    editLoading: false,
    error: null,
    isLoading: false,
  });
  const { token } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageName = searchParams.get("pagename");
  const itemId = searchParams.get("itemid");
  const type = searchParams.get("type");
  const editmode = searchParams.get("editmode");

  useEffect(() => {
    console.log(props);
    window.scrollTo(0, 0);

    loadResources();

    const socket = openSocket(getApiBaseUrl("http"));

    socket.on("items", (data) => {
      if (data.action === "create") {
        addItem(data.item);
      } else if (data.action === "update") {
        updateItem(data.item);
      } else if (data.action === "delete") {
        deleteItem(data.itemId);
      }
    });
    return () => {
      socket.off("resources");
      socket.disconnect();
    };
  }, [pageName]);

  const loadResources = async () => {
    setState((prevState) => {
      return { ...prevState, isLoading: true };
    });
    const { data, error } = await getResources(pageName);
    console.log(data);
    if ((!data, error)) {
      return setState({
        resources: [],
        editResource: null,
        editLoading: false,
        errorMessage: "Couldn't load items.",
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        resources: data.resources,
        isLoading: false,
      };
    });
  };

  const updateItem = (resource) => {
    setState((prevState) => {
      const updatedResources = [...prevState.resources];
      const updatedResourceIndex = updatedResources.findIndex(
        (p) => p._id === resource._id
      );
      if (updatedResourceIndex > -1) {
        updatedResources[updatedResourceIndex] = resource;
      }
      return {
        ...prevState,
        resources: updatedResources,
      };
    });
  };

  const addItem = (resource) => {
    setState((prevState) => {
      const updatedResources = [...prevState.resources];
      updatedResources.unshift(resource);
      return {
        ...prevState,
        resources: updatedResources,
      };
    });
  };

  const deleteItem = (resourceId) => {
    setState((prevState) => {
      const updatedResources = [...prevState.resources];
      const updatedResourceIndex = updatedResources.findIndex(
        (p) => p._id === resourceId
      );
      updatedResources.splice(updatedResourceIndex, 1);
      return {
        ...prevState,
        resources: updatedResources,
      };
    });
  };

  const startEditHandler = (id) => {
    searchParams.set("editmode", true);
    searchParams.set("itemid", id);

    const newUrl = `${location.pathname}?${searchParams.toString()}`;

    navigate(newUrl);
  };

  const cancelEditHandler = () => {
    searchParams.delete("editmode");
    searchParams.delete("itemid");

    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    setState((prevState) => {
      return {
        ...prevState,
        errorMessage: null,
      };
    });
    navigate(newUrl);
  };

  const finishEditHandler = async (resourceData) => {
    setState((prevState) => {
      return { ...prevState, editLoading: true };
    });

    const formData = new FormData();

    Object.entries(resourceData).forEach(([key, value]) => {
      if (key === "links") {
        formData.append("links", JSON.stringify(resourceData.links));
      } else {
        formData.append(key, value);
      }
    });

    const { data, error } = await updateResource(
      pageName,
      token,
      itemId,
      formData
    );

    if (error) {
      return setState((prevState) => {
        return {
          ...prevState,
          editResource: null,
          editLoading: false,
          errorMessage: "Adding or Edting item failed.",
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,

        editResource: null,
        editLoading: false,
      };
    });
    searchParams.delete("editmode");
    searchParams.delete("itemid");
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl);
  };

  const newResourceHandler = () => {
    searchParams.set("editmode", true);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl);
  };

  const deleteResourceHandler = async (resourceId) => {
    const { data, error } = await deleteResource(pageName, token, resourceId);
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isLoading: false,
          errorMessage: "Deleting item failed.",
        };
      });
    }
  };

  return (
    <LoadingContext.Provider value={state.isLoading || state.editLoading}>
      <Error error={state.errorMessage} onHandle={cancelEditHandler} />
      {editmode && (
        <Form
          page={"SdgsProject"}
          items={state.resources}
          editLoading={state.editLoading}
          loading={state.isLoading || state.editLoading}
          onCancelEdit={cancelEditHandler}
          onFinishEdit={finishEditHandler}
        />
      )}
      <PageContainer
        onAddItem={newResourceHandler}
        title={pageName === "sdgsProjects" ? "SDGs&Projects" : pageName}
      >
        {state.isLoading ? (
          <span className="loading loading-spinner loading-lg self-center"></span>
        ) : (
          state.resources.map((item) => {
            return (
              <>
                {type === "content" && (
                  <ContentItems
                    onStartEdit={startEditHandler.bind(this, item._id)}
                    key={item._id}
                    name={item.name}
                    description={item.description}
                    image={item.imageURL}
                    links={item.links}
                    onDelete={deleteResourceHandler.bind(this, item._id)}
                  />
                )}
                {type === "support" && (
                  <SupportItems
                    onStartEdit={startEditHandler.bind(this, item._id)}
                    key={item._id}
                    type={item.type}
                    name={item.name}
                    url={item.url}
                    onDelete={deleteResourceHandler.bind(this, item._id)}
                  />
                )}
              </>
            );
          })
        )}
      </PageContainer>
    </LoadingContext.Provider>
  );
}

export default ResourcePages;
